import { docReadV2Command } from './doc_read';
import { docReplaceV2Command } from './doc_replace';
import { SimpleDocCommand } from './types';
import { docWriteCommand } from './doc_write';
// import { docReviewCommand } from './doc_review'; // [DELISTED - keep code but hide from AI]
import { docGenerateImageCommand } from './doc_generate_image';
import { docGenerateImageV2Command } from './doc_generate_image_v2';
import { startManuscriptAnalysisCommand } from './start_manuscript_analysis';
import { docsAddCommentCommand } from './docs_add_comment';
import { aiDetectCommand } from './ai_detect';
import { detectAICommand } from './detect_ai';
import { docGetMetadataCommand } from './doc_get_metadata';

export const markdownDocCommands: SimpleDocCommand[] = [
  docReadV2Command,
  docReplaceV2Command,
  docWriteCommand,
  docGetMetadataCommand,
  // docReviewCommand, // [DELISTED - keep code but hide from AI]
  docGenerateImageCommand,
  docGenerateImageV2Command,
  startManuscriptAnalysisCommand,
  docsAddCommentCommand,
  aiDetectCommand,
  detectAICommand,
];

export function registerV5Commands() {
  const { registerSelfContainedCommands } = require('stores/commandRegistryStore');
  registerSelfContainedCommands(markdownDocCommands);
}
